import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

/** «تسجيل الدخول · PopupPush» — set in an effect, re-set when the language flips. */
export default function useAuthTitle(screen) {
  const { t, i18n } = useTranslation();
  const lng = i18n.resolvedLanguage;
  useEffect(() => {
    document.title = `${t(`authPage.titles.${screen}`)} · PopupPush`;
  }, [screen, lng, t]);
}
